import { motion } from "framer-motion";
import { X } from "lucide-react";

/**
 * AssistantIndicator - مؤشر المساعد الحالي
 * @param {Object} assistant - بيانات المساعد
 * @param {boolean} isRTL - هل اللغة من اليمين لليسار
 * @param {Function} onClose - إغلاق المساعد
 */
export function AssistantIndicator({ assistant, isRTL, onClose }) {
  if (!assistant) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-4 mt-2 mb-2 flex items-center justify-center gap-2 px-4 py-2.5 rounded-2xl backdrop-blur-sm border border-border/50"
      style={{ backgroundColor: `${assistant.color}15` }}
    >
      <span className="text-xl">{assistant.icon}</span>
      <span className="text-sm font-semibold" style={{ color: assistant.color }}>
        {isRTL ? assistant.name_ar : assistant.name}
      </span>
      <button
        onClick={onClose}
        className="mr-2 p-1 rounded-full hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground"
      >
        <X className="w-4 h-4" />
      </button>
    </motion.div>
  );
}

export default AssistantIndicator;
